import { render, staticRenderFns } from "./LayerFullscreenHeader.vue?vue&type=template&id=7c74d80a&scoped=true&name=LayerFullscreen&"
import script from "./LayerFullscreenHeader.vue?vue&type=script&lang=js&"
export * from "./LayerFullscreenHeader.vue?vue&type=script&lang=js&"
import style0 from "./LayerFullscreenHeader.vue?vue&type=style&index=0&id=7c74d80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c74d80a",
  null
  
)

export default component.exports